import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function PersonalDevelopmentPlan({ phase }) {
  const isCaptureProgress = phase === 'capture-progress';
  const [plans, setPlans] = useState([
    {
      competency: 'Financial Management',
      actions: 'Find applicable course on Internal LMS system',
      responsibility: 'Finish and pass the course. Apply knowledge accordingly.',
      progressOutcome: '',
    },
    {
      competency: 'Proposal Writing',
      actions: 'Find applicable course on Internal LMS system',
      responsibility: 'Finish and pass the course. Improvement in proposal writing.',
      progressOutcome: '',
    },
  ]);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [newPlan, setNewPlan] = useState({
    competency: '',
    actions: '',
    responsibility: '',
    progressOutcome: '',
  });
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(null);
  const [isEditingPlan, setIsEditingPlan] = useState(false);

  const handleAddPlan = () => {
    console.log('handleAddPlan called with newPlan:', newPlan);
    const missingFields = [];
    if (!newPlan.competency) missingFields.push('Competency to Address');
    if (!newPlan.actions) missingFields.push('Proposed Actions');
    if (!newPlan.responsibility) missingFields.push('Responsibility');

    if (missingFields.length > 0) {
      alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
      console.log('Validation failed, missing required fields:', missingFields);
      return;
    }

    console.log('Required fields valid, adding Plan');
    setPlans([...plans, { ...newPlan }]);
    setNewPlan({
      competency: '',
      actions: '',
      responsibility: '',
      progressOutcome: '',
    });
    setShowPlanModal(false);
    console.log('Plan added, updated plans:', plans);
  };

  const handleEditPlan = (index) => {
    console.log('handleEditPlan called for index:', index);
    setSelectedPlanIndex(index);
    setNewPlan({ ...plans[index] });
    setIsEditingPlan(true);
    setShowPlanModal(true);
  };

  const handleSaveEditPlan = () => {
    console.log('handleSaveEditPlan called with newPlan:', newPlan);
    console.log('selectedPlanIndex:', selectedPlanIndex);
    const missingFields = [];
    if (!newPlan.competency) missingFields.push('Competency to Address');
    if (!newPlan.actions) missingFields.push('Proposed Actions');
    if (!newPlan.responsibility) missingFields.push('Responsibility');

    if (missingFields.length > 0) {
      alert(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
      console.log('Validation failed, missing required fields:', missingFields);
      return;
    }

    console.log('Required fields valid, updating Plan');
    const updatedPlans = [...plans];
    updatedPlans[selectedPlanIndex] = { ...newPlan };
    setPlans(updatedPlans);
    setNewPlan({
      competency: '',
      actions: '',
      responsibility: '',
      progressOutcome: '',
    });
    setShowPlanModal(false);
    setSelectedPlanIndex(null);
    setIsEditingPlan(false);
    console.log('Plan updated, updated plans:', updatedPlans);
  };

  const handleDeletePlan = () => {
    console.log('handleDeletePlan called for index:', selectedPlanIndex);
    const updatedPlans = plans.filter((_, index) => index !== selectedPlanIndex);
    setPlans(updatedPlans);
    setNewPlan({
      competency: '',
      actions: '',
      responsibility: '',
      progressOutcome: '',
    });
    setShowPlanModal(false);
    setSelectedPlanIndex(null);
    setIsEditingPlan(false);
    console.log('Plan deleted, updated plans:', updatedPlans);
  };

  const handleProgressOutcomeChange = (index, value) => {
    console.log('handleProgressOutcomeChange called for index:', index, 'value:', value);
    const updatedPlans = [...plans];
    updatedPlans[index].progressOutcome = value;
    setPlans(updatedPlans);
  };

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center mb-3 bg-tertiary p-2 text-light rounded">
        <h4 className="mb-0">Section C: Personal Development Plan</h4>
        <button
          type="button"
          className="btn btn-primary ms-auto"
          onClick={() => setShowPlanModal(true)}
          disabled={isCaptureProgress}
        >
          Add New Plan
        </button>
      </div>
      <div className="mt-4">
        <table className="table table-bordereds">
          <thead className="bg-tertiary text-light">
            <tr>
              <th>Competency to Address</th>
              <th>Proposed Actions</th>
              <th>Responsibility</th>
              <th>Progress / Outcome</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {plans.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">No Plans added</td>
              </tr>
            ) : (
              plans.map((plan, index) => (
                <tr key={`plan-${index}`}>
                  <td>
                    <textarea
                      className="form-control"
                      value={plan.competency}
                      readOnly
                      disabled
                      rows={4}
                    />
                  </td>
                  <td>
                    <textarea
                      className="form-control"
                      value={plan.actions}
                      readOnly
                      disabled
                      rows={4}
                    />
                  </td>
                  <td>
                    <textarea
                      className="form-control"
                      value={plan.responsibility}
                      readOnly
                      disabled
                      rows={4}
                    />
                  </td>
                  <td>
                    <textarea
                      className="form-control"
                      value={plan.progressOutcome}
                      onChange={(e) => handleProgressOutcomeChange(index, e.target.value)}
                      rows={4}
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => handleEditPlan(index)}
                      disabled={isCaptureProgress}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className={`modal fade ${showPlanModal ? 'show d-block' : ''}`} style={{ backgroundColor: showPlanModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isEditingPlan ? 'Edit Plan' : 'Add New Plan'}</h5>
              <button type="button" className="btn-close" onClick={() => setShowPlanModal(false)} />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="planCompetency" className="form-label">Competency to Address</label>
                <textarea
                  className="form-control"
                  id="planCompetency"
                  value={newPlan.competency}
                  onChange={(e) => setNewPlan({ ...newPlan, competency: e.target.value })}
                  rows={4}
                  readOnly={isCaptureProgress}
                  disabled={isCaptureProgress}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="planActions" className="form-label">Proposed Actions</label>
                <textarea
                  className="form-control"
                  id="planActions"
                  value={newPlan.actions}
                  onChange={(e) => setNewPlan({ ...newPlan, actions: e.target.value })}
                  rows={4}
                  readOnly={isCaptureProgress}
                  disabled={isCaptureProgress}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="planResponsibility" className="form-label">Responsibility</label>
                <textarea
                  className="form-control"
                  id="planResponsibility"
                  value={newPlan.responsibility}
                  onChange={(e) => setNewPlan({ ...newPlan, responsibility: e.target.value })}
                  rows={4}
                  readOnly={isCaptureProgress}
                  disabled={isCaptureProgress}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="planProgressOutcome" className="form-label">Progress / Challenges / Corrective Measures (Optional)</label>
                <textarea
                  className="form-control"
                  id="planProgressOutcome"
                  value={newPlan.progressOutcome}
                  onChange={(e) => setNewPlan({ ...newPlan, progressOutcome: e.target.value })}
                  rows={4}
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="d-flex w-100">
                <button
                  type="button"
                  className="btn btn-danger btn-sm me-auto"
                  onClick={handleDeletePlan}
                  style={{ visibility: isEditingPlan ? 'visible' : 'hidden' }}
                  disabled={isCaptureProgress}
                >
                  Delete
                </button>
                <div>
                  <button type="button" className="btn btn-secondary me-2" onClick={() => setShowPlanModal(false)}>
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={isEditingPlan ? handleSaveEditPlan : handleAddPlan}
                    disabled={isCaptureProgress}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalDevelopmentPlan;